import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { getEffectivePermission, hasPermission, canRead as _canRead, canManage as _canManage, READ, MANAGE } from '../utils/permissions';

/**
 * Hook for checking module permissions of the current user.
 * Usage:
 *   const { canRead, canManage, getPermission } = usePermissions();
 *   if (canManage('remuneraciones')) { ... }
 */
export function usePermissions() {
  const { user } = useAuth();

  const getPermission = useCallback((module) => {
    return getEffectivePermission(user, module);
  }, [user]);

  const canRead = useCallback((module) => {
    return _canRead(user, module);
  }, [user]);

  const canManage = useCallback((module) => {
    return _canManage(user, module);
  }, [user]);

  const checkPermission = useCallback((module, required = READ) => {
    return hasPermission(user, module, required);
  }, [user]);

  return { getPermission, canRead, canManage, checkPermission, user };
}
